import { render, staticRenderFns } from "./AccountResetPassword.vue?vue&type=template&id=08b759b3&"
import script from "./AccountResetPassword.vue?vue&type=script&lang=js&"
export * from "./AccountResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports